// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ForetagRouteImport } from './routes/foretag'
import { Route as ForfraganRouteImport } from './routes/forfragan'
import { Route as GymnasiumRouteImport } from './routes/gymnasium'
import { Route as HogskolaRouteImport } from './routes/hogskola'
import { Route as HoppborgarRouteImport } from './routes/hoppborgar'
import { Route as KommunRouteImport } from './routes/kommun'
import { Route as KonceptRouteImport } from './routes/koncept'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as MassaRouteImport } from './routes/massa'
import { Route as OmOssRouteImport } from './routes/om-oss'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as ScenLjudLjusRouteImport } from './routes/scen-ljud-ljus'
import { Route as SidkartaRouteImport } from './routes/sidkarta'
import { Route as SkolaRouteImport } from './routes/skola'
import { Route as TackRouteImport } from './routes/tack'
import { Route as TivolispelRouteImport } from './routes/tivolispel'
import { Route as VintereventRouteImport } from './routes/vinterevent'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminCategoriesRouteImport } from './routes/admin.categories'
import { Route as AdminDraftsRouteImport } from './routes/admin.drafts'
import { Route as AdminImportRouteImport } from './routes/admin.import'
import { Route as AdminInboxRouteImport } from './routes/admin.inbox'
import { Route as AdminInquiriesRouteImport } from './routes/admin.inquiries'
import { Route as AdminMediaRouteImport } from './routes/admin.media'
import { Route as AdminProductsRouteImport } from './routes/admin.products'
import { Route as AdminSupportRouteImport } from './routes/admin.support'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as ForetagIndexRouteImport } from './routes/foretag.index'
import { Route as ForetagStadRouteImport } from './routes/foretag.$stad'
import { Route as GymnasiumIndexRouteImport } from './routes/gymnasium.index'
import { Route as GymnasiumStadRouteImport } from './routes/gymnasium.$stad'
import { Route as HogskolaIndexRouteImport } from './routes/hogskola.index'
import { Route as HogskolaStadRouteImport } from './routes/hogskola.$stad'
import { Route as KategoriSlugRouteImport } from './routes/kategori.$slug'
import { Route as KommunIndexRouteImport } from './routes/kommun.index'
import { Route as KommunStadRouteImport } from './routes/kommun.$stad'
import { Route as KonceptIndexRouteImport } from './routes/koncept.index'
import { Route as KonceptSlugRouteImport } from './routes/koncept.$slug'
import { Route as MassaIndexRouteImport } from './routes/massa.index'
import { Route as MassaStadRouteImport } from './routes/massa.$stad'
import { Route as ProdukterIndexRouteImport } from './routes/produkter.index'
import { Route as ProdukterSlugRouteImport } from './routes/produkter.$slug'
import { Route as SkolaIndexRouteImport } from './routes/skola.index'
import { Route as SkolaStadRouteImport } from './routes/skola.$stad'
import { Route as AdminCategoriesIndexRouteImport } from './routes/admin.categories.index'
import { Route as AdminCategoriesIdRouteImport } from './routes/admin.categories.$id'
import { Route as AdminCategoriesNewRouteImport } from './routes/admin.categories.new'
import { Route as AdminDraftsIndexRouteImport } from './routes/admin.drafts.index'
import { Route as AdminDraftsIdRouteImport } from './routes/admin.drafts.$id'
import { Route as AdminInquiriesIndexRouteImport } from './routes/admin.inquiries.index'
import { Route as AdminInquiriesIdRouteImport } from './routes/admin.inquiries.$id'
import { Route as AdminProductsIndexRouteImport } from './routes/admin.products.index'
import { Route as AdminProductsIdRouteImport } from './routes/admin.products.$id'
import { Route as AdminProductsNewRouteImport } from './routes/admin.products.new'
import { Route as AdminUsersIndexRouteImport } from './routes/admin.users.index'
import { Route as AdminUsersIdRouteImport } from './routes/admin.users.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ForetagRoute = ForetagRouteImport.update({
            id: '/foretag',path: '/foretag',getParentRoute: () => rootRouteImport
          })
const ForfraganRoute = ForfraganRouteImport.update({
            id: '/forfragan',path: '/forfragan',getParentRoute: () => rootRouteImport
          })
const GymnasiumRoute = GymnasiumRouteImport.update({
            id: '/gymnasium',path: '/gymnasium',getParentRoute: () => rootRouteImport
          })
const HogskolaRoute = HogskolaRouteImport.update({
            id: '/hogskola',path: '/hogskola',getParentRoute: () => rootRouteImport
          })
const HoppborgarRoute = HoppborgarRouteImport.update({
            id: '/hoppborgar',path: '/hoppborgar',getParentRoute: () => rootRouteImport
          })
const KommunRoute = KommunRouteImport.update({
            id: '/kommun',path: '/kommun',getParentRoute: () => rootRouteImport
          })
const KonceptRoute = KonceptRouteImport.update({
            id: '/koncept',path: '/koncept',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const MassaRoute = MassaRouteImport.update({
            id: '/massa',path: '/massa',getParentRoute: () => rootRouteImport
          })
const OmOssRoute = OmOssRouteImport.update({
            id: '/om-oss',path: '/om-oss',getParentRoute: () => rootRouteImport
          })
const PartnerRoute = PartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => rootRouteImport
          })
const ScenLjudLjusRoute = ScenLjudLjusRouteImport.update({
            id: '/scen-ljud-ljus',path: '/scen-ljud-ljus',getParentRoute: () => rootRouteImport
          })
const SidkartaRoute = SidkartaRouteImport.update({
            id: '/sidkarta',path: '/sidkarta',getParentRoute: () => rootRouteImport
          })
const SkolaRoute = SkolaRouteImport.update({
            id: '/skola',path: '/skola',getParentRoute: () => rootRouteImport
          })
const TackRoute = TackRouteImport.update({
            id: '/tack',path: '/tack',getParentRoute: () => rootRouteImport
          })
const TivolispelRoute = TivolispelRouteImport.update({
            id: '/tivolispel',path: '/tivolispel',getParentRoute: () => rootRouteImport
          })
const VintereventRoute = VintereventRouteImport.update({
            id: '/vinterevent',path: '/vinterevent',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AdminRoute
          })
const AdminDraftsRoute = AdminDraftsRouteImport.update({
            id: '/drafts',path: '/drafts',getParentRoute: () => AdminRoute
          })
const AdminImportRoute = AdminImportRouteImport.update({
            id: '/import',path: '/import',getParentRoute: () => AdminRoute
          })
const AdminInboxRoute = AdminInboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => AdminRoute
          })
const AdminInquiriesRoute = AdminInquiriesRouteImport.update({
            id: '/inquiries',path: '/inquiries',getParentRoute: () => AdminRoute
          })
const AdminMediaRoute = AdminMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => AdminRoute
          })
const AdminProductsRoute = AdminProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AdminRoute
          })
const AdminSupportRoute = AdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const ForetagIndexRoute = ForetagIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ForetagRoute
          })
const ForetagStadRoute = ForetagStadRouteImport.update({
            id: '/$stad',path: '/$stad',getParentRoute: () => ForetagRoute
          })
const GymnasiumIndexRoute = GymnasiumIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GymnasiumRoute
          })
const GymnasiumStadRoute = GymnasiumStadRouteImport.update({
            id: '/$stad',path: '/$stad',getParentRoute: () => GymnasiumRoute
          })
const HogskolaIndexRoute = HogskolaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HogskolaRoute
          })
const HogskolaStadRoute = HogskolaStadRouteImport.update({
            id: '/$stad',path: '/$stad',getParentRoute: () => HogskolaRoute
          })
const KategoriSlugRoute = KategoriSlugRouteImport.update({
            id: '/kategori/$slug',path: '/kategori/$slug',getParentRoute: () => rootRouteImport
          })
const KommunIndexRoute = KommunIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => KommunRoute
          })
const KommunStadRoute = KommunStadRouteImport.update({
            id: '/$stad',path: '/$stad',getParentRoute: () => KommunRoute
          })
const KonceptIndexRoute = KonceptIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => KonceptRoute
          })
const KonceptSlugRoute = KonceptSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => KonceptRoute
          })
const MassaIndexRoute = MassaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MassaRoute
          })
const MassaStadRoute = MassaStadRouteImport.update({
            id: '/$stad',path: '/$stad',getParentRoute: () => MassaRoute
          })
const ProdukterIndexRoute = ProdukterIndexRouteImport.update({
            id: '/produkter/',path: '/produkter/',getParentRoute: () => rootRouteImport
          })
const ProdukterSlugRoute = ProdukterSlugRouteImport.update({
            id: '/produkter/$slug',path: '/produkter/$slug',getParentRoute: () => rootRouteImport
          })
const SkolaIndexRoute = SkolaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SkolaRoute
          })
const SkolaStadRoute = SkolaStadRouteImport.update({
            id: '/$stad',path: '/$stad',getParentRoute: () => SkolaRoute
          })
const AdminCategoriesIndexRoute = AdminCategoriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminCategoriesRoute
          })
const AdminCategoriesIdRoute = AdminCategoriesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminCategoriesRoute
          })
const AdminCategoriesNewRoute = AdminCategoriesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminCategoriesRoute
          })
const AdminDraftsIndexRoute = AdminDraftsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminDraftsRoute
          })
const AdminDraftsIdRoute = AdminDraftsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminDraftsRoute
          })
const AdminInquiriesIndexRoute = AdminInquiriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminInquiriesRoute
          })
const AdminInquiriesIdRoute = AdminInquiriesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminInquiriesRoute
          })
const AdminProductsIndexRoute = AdminProductsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminProductsRoute
          })
const AdminProductsIdRoute = AdminProductsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminProductsRoute
          })
const AdminProductsNewRoute = AdminProductsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminProductsRoute
          })
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminUsersRoute
          })
const AdminUsersIdRoute = AdminUsersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminUsersRoute
          })





const AdminCategoriesRouteChildren = {
  AdminCategoriesIdRoute: AdminCategoriesIdRoute,AdminCategoriesNewRoute: AdminCategoriesNewRoute,AdminCategoriesIndexRoute: AdminCategoriesIndexRoute
}

const AdminCategoriesRouteWithChildren = AdminCategoriesRoute._addFileChildren(AdminCategoriesRouteChildren)




const AdminDraftsRouteChildren = {
  AdminDraftsIdRoute: AdminDraftsIdRoute,AdminDraftsIndexRoute: AdminDraftsIndexRoute
}

const AdminDraftsRouteWithChildren = AdminDraftsRoute._addFileChildren(AdminDraftsRouteChildren)




const AdminInquiriesRouteChildren = {
  AdminInquiriesIdRoute: AdminInquiriesIdRoute,AdminInquiriesIndexRoute: AdminInquiriesIndexRoute
}

const AdminInquiriesRouteWithChildren = AdminInquiriesRoute._addFileChildren(AdminInquiriesRouteChildren)




const AdminProductsRouteChildren = {
  AdminProductsIdRoute: AdminProductsIdRoute,AdminProductsNewRoute: AdminProductsNewRoute,AdminProductsIndexRoute: AdminProductsIndexRoute
}

const AdminProductsRouteWithChildren = AdminProductsRoute._addFileChildren(AdminProductsRouteChildren)




const AdminUsersRouteChildren = {
  AdminUsersIdRoute: AdminUsersIdRoute,AdminUsersIndexRoute: AdminUsersIndexRoute
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(AdminUsersRouteChildren)



const AdminRouteChildren = {
  AdminCategoriesRoute: AdminCategoriesRouteWithChildren,AdminDraftsRoute: AdminDraftsRouteWithChildren,AdminImportRoute: AdminImportRoute,AdminInboxRoute: AdminInboxRoute,AdminInquiriesRoute: AdminInquiriesRouteWithChildren,AdminMediaRoute: AdminMediaRoute,AdminProductsRoute: AdminProductsRouteWithChildren,AdminSupportRoute: AdminSupportRoute,AdminUsersRoute: AdminUsersRouteWithChildren,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const ForetagRouteChildren = {
  ForetagStadRoute: ForetagStadRoute,ForetagIndexRoute: ForetagIndexRoute
}

const ForetagRouteWithChildren = ForetagRoute._addFileChildren(ForetagRouteChildren)




const GymnasiumRouteChildren = {
  GymnasiumStadRoute: GymnasiumStadRoute,GymnasiumIndexRoute: GymnasiumIndexRoute
}

const GymnasiumRouteWithChildren = GymnasiumRoute._addFileChildren(GymnasiumRouteChildren)




const HogskolaRouteChildren = {
  HogskolaStadRoute: HogskolaStadRoute,HogskolaIndexRoute: HogskolaIndexRoute
}

const HogskolaRouteWithChildren = HogskolaRoute._addFileChildren(HogskolaRouteChildren)




const KommunRouteChildren = {
  KommunStadRoute: KommunStadRoute,KommunIndexRoute: KommunIndexRoute
}

const KommunRouteWithChildren = KommunRoute._addFileChildren(KommunRouteChildren)




const KonceptRouteChildren = {
  KonceptSlugRoute: KonceptSlugRoute,KonceptIndexRoute: KonceptIndexRoute
}

const KonceptRouteWithChildren = KonceptRoute._addFileChildren(KonceptRouteChildren)




const MassaRouteChildren = {
  MassaStadRoute: MassaStadRoute,MassaIndexRoute: MassaIndexRoute
}

const MassaRouteWithChildren = MassaRoute._addFileChildren(MassaRouteChildren)




const SkolaRouteChildren = {
  SkolaStadRoute: SkolaStadRoute,SkolaIndexRoute: SkolaIndexRoute
}

const SkolaRouteWithChildren = SkolaRoute._addFileChildren(SkolaRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,FaqRoute: FaqRoute,ForetagRoute: ForetagRouteWithChildren,ForfraganRoute: ForfraganRoute,GymnasiumRoute: GymnasiumRouteWithChildren,HogskolaRoute: HogskolaRouteWithChildren,HoppborgarRoute: HoppborgarRoute,KommunRoute: KommunRouteWithChildren,KonceptRoute: KonceptRouteWithChildren,KontaktRoute: KontaktRoute,MassaRoute: MassaRouteWithChildren,OmOssRoute: OmOssRoute,PartnerRoute: PartnerRoute,ScenLjudLjusRoute: ScenLjudLjusRoute,SidkartaRoute: SidkartaRoute,SkolaRoute: SkolaRouteWithChildren,TackRoute: TackRoute,TivolispelRoute: TivolispelRoute,VintereventRoute: VintereventRoute,KategoriSlugRoute: KategoriSlugRoute,ProdukterSlugRoute: ProdukterSlugRoute,ProdukterIndexRoute: ProdukterIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)